(function ($, elementorFrontend) {
	function init($slide, index = 0) {
		let images = $($slide).find(".slide-with-image__slide__image__inner");
		let content = $($slide).find(
			".slide-with-image__slide__content__inner",
		);
		let nav = $($slide).find(".slide-with-image__slide__dots");
		let _currentSlide = 0;

		$(images).slick({
			dots: false,
			infinite: true,
			speed: 1500,
			slidesToShow: 1,
			autoplay: false,
			arrows: false,
			fade: true,
		});
		$(content).slick({
			dots: false,
			infinite: true,
			speed: 1500,
			slidesToShow: 1,
			autoplay: false,
			arrows: false,
			fade: true,
		});

		$(nav)
			.slick({
				speed: 1500,
				slidesToShow: 1,
				arrows: false,
				dots: true,
				autoplay: true,
			})
			.slick("slickPause");

		$(nav).on(
			"beforeChange",
			function (event, slick, currentSlide, nextSlide) {
				$(images).slick("slickGoTo", nextSlide);
				$(content).slick("slickGoTo", nextSlide);
			},
		);

		$(images).on(
			"beforeChange",
			function (event, slick, currentSlide, nextSlide) {
				$(nav).slick("slickGoTo", nextSlide);
				$(content).slick("slickGoTo", nextSlide);
			},
		);

		$(content).on(
			"beforeChange",
			function (event, slick, currentSlide, nextSlide) {
				$(nav).slick("slickGoTo", nextSlide);
				$(images).slick("slickGoTo", nextSlide);
				_currentSlide = nextSlide;
			},
		);

		setTimeout(() => {
			$(nav).slick("slickPlay");
		}, 3000 * (index % 2));
	}

	$(".slide-with-image").each(function (index, el) {
		init(el, index);
	});

	$(window).on("elementor/frontend/init", () => {
		setTimeout(() => {
			const $slides =
				elementorFrontend.elements.$body.find(".slide-with-image");

			$($slides).each(function (index, el) {
				init(el, index);
			});
		}, 2000);

		elementorFrontend.hooks.addAction(
			"frontend/element_ready/cm-slider.default",
			($sope) => {
				var $slide = $sope.find(".slide-with-image");
				init($slide);
			},
		);
	});
})(jQuery, window.elementorFrontend);
